module.exports = {"440310001":"坪山街道","440310002":"马峦街道","440310003":"碧岭街道","440310004":"石井街道","440310005":"坑梓街道","440310006":"龙田街道","440310401":"深圳坪山综合保税区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440310.json
// module id = 2099
// module chunks = 0